export const getSurveyId = state => state.survey?.survey?._id;

export const getHasOnboardingSurvey = state =>
  Boolean(state.survey.survey._id) || false;
